import AutoQuery from "servicestack/auto-query/auto-query";
import { ModelPrompt, ModelPromptController } from "webmodals/model-prompt";
import deleteTemplate from "emun.retailer/retailer-delete-confirmation.htm";
import labels from "emun.retailer/_labels";
import fieldsetTemplate from "emun.retailer/retailer-fieldset.htm";
import startTemplate from "emun.retailer/retailer-start-fieldset.htm";
import $session from "servicestack/session";
import ServiceBus from "servicestack/service-bus";
import customerConfig from "emun.customer/customer.config";

export class RetailerPromptController extends ModelPromptController {
  constructor($uibModalInstance, options) {
    super(options);
    const $ctrl = this;
    $ctrl.modal = $uibModalInstance;
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $ctrl.close = $uibModalInstance.close;
    $ctrl.$geo = $ctrl.$ioc("$geo");
    $ctrl.customerConfig = customerConfig;
    $ctrl.labels = labels;
    $ctrl.noEmail = false;
  }

  $onInit() {
    const $ctrl = this;
    if ($ctrl.request.id) {
      ServiceBus.send(
        "QueryRetailerShippingLocations.json?RetailerId=" + $ctrl.request.id
      ).then((res) => {
        if (res.data.results.length > 0) {
          $ctrl.request.shippingLocation = res.data.results[0];
        }
      });
      ServiceBus.send(
        "QueryRetailerContacts.json?RetailerId=" +
          $ctrl.request.id +
          "&isPrimary=1"
      ).then((res) => {
        if (res.data.results.length > 0) {
          $ctrl.request.primaryContact = res.data.results[0];
        }
      });
    } else {
      $ctrl.request.primaryContact = {};
      $ctrl.request.shippingLocation = {
        country: customerConfig.defaultCountry || "US",
      };
      $ctrl.request.tags = {};
      // $ctrl.request.tags["TaxExemption"] = utils.uuid();
      // $ctrl.request.tags["SalesTaxCertificate"] = utils.uuid();
    }
    $ctrl.request.allowEmptyAddress = $ctrl.customerConfig.allowEmptyAddress
      ? true
      : false;
    if ($ctrl.customerConfig.defaultAccountType && !$ctrl.request.accountType)
      $ctrl.request.accountType = $ctrl.customerConfig.defaultAccountType;
    if ($ctrl.customerConfig.defaultPriceList && !$ctrl.request.priceList)
      $ctrl.request.priceList = $ctrl.customerConfig.defaultPriceList;
  }

  findOtherRetailers(name, zip) {
    const $ctrl = this;
    $ctrl.otherRetailers = new AutoQuery({
      url:
        "QueryRetailersSearch.json?CompanyNameStartsWith=" +
        name.substring(0, 1) +
        "&ZipStartsWith=" +
        zip.substring(0, 5),
      autoLoad: true,
      onLoaded: (args) => ($ctrl.duplicates = args.results),
    });
  }

  checkDuplicateZip() {
    const $ctrl = this;
    $ctrl.duplicateZips = ($ctrl.otherLocations || []).filter(
      (m) =>
        m.id !== $ctrl.request.id &&
        $ctrl.request.zip &&
        $ctrl.request.zip.length >= 5 &&
        m.zip.startsWith($ctrl.request.zip.substring(0, 5))
    );
  }

  selectAddress(item, request) {
    const $ctrl = this;
    $ctrl.$geo.apply(item, request);
    $ctrl.copyFromBilling();
  }

  toggleSameAsBilling() {
    const $ctrl = this;
    if ($ctrl.sameAsBilling) {
      $ctrl.copyFromBilling();
    } else {
      $ctrl.request.shippingLocation.companyName = "";
      $ctrl.request.shippingLocation.address = "";
      $ctrl.request.shippingLocation.address2 = "";
      $ctrl.request.shippingLocation.city = "";
      $ctrl.request.shippingLocation.state = "";
      $ctrl.request.shippingLocation.zip = "";
      $ctrl.request.shippingLocation.country = "";
      $ctrl.request.shippingLocation.phone = "";
    }
  }

  copyFromBilling() {
    const $ctrl = this;
    console.debug("copyFromBilling", $ctrl.request.primaryContact);
    if (
      $ctrl.request.primaryContact != undefined &&
      !$ctrl.request.primaryContact.email
    )
      $ctrl.request.primaryContact.email = $ctrl.request.email;
    if (
      $ctrl.request.primaryContact != undefined &&
      !$ctrl.request.primaryContact.phone
    )
      $ctrl.request.primaryContact.phone = $ctrl.request.phone;

//    if (!$ctrl.request.shippingLocation.companyName)
      $ctrl.request.shippingLocation.companyName = $ctrl.request.companyName;
//    if (!$ctrl.request.shippingLocation.address)
      $ctrl.request.shippingLocation.address = $ctrl.request.address;
//    if (!$ctrl.request.shippingLocation.address2)
      $ctrl.request.shippingLocation.address2 = $ctrl.request.address2;
//    if (!$ctrl.request.shippingLocation.city)
      $ctrl.request.shippingLocation.city = $ctrl.request.city;
//    if (!$ctrl.request.shippingLocation.state)
      $ctrl.request.shippingLocation.state = $ctrl.request.state;
//    if (!$ctrl.request.shippingLocation.zip)
      $ctrl.request.shippingLocation.zip = $ctrl.request.zip;
    //if (!$ctrl.request.shippingLocation.country)
    $ctrl.request.shippingLocation.country = $ctrl.request.country;
//    if (!$ctrl.request.shippingLocation.phone)
      $ctrl.request.shippingLocation.phone = $ctrl.request.phone;
  }

  noEmailSet() {
    const $ctrl = this;
    $ctrl.noEmail = !$ctrl.noEmail;
  }

  upload($files, documentType) {
    let $ctrl = this;
    if ($files && $files.length) {
      let req = {
        request: {
          realm: "RetailerRegistration",
          tags: {
            DocumentType: documentType,
          },
        },
        files: $files,
        urls: [],
      };

      $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
        $ctrl.request.tags[documentType] = response.data.media[0].key;
      });
    }
  }
  openDocument(url, docType) {
    let $ctrl = this;
    window.open("https://emun-on-demand.s3.amazonaws.com/" + url, docType);
  }
}

export default class RetailerPrompt extends ModelPrompt {
  constructor($geo) {
    super();
    let $ctrl = this;
    $ctrl.$geo = $geo;
    this.seed = {
      status: "Active",
      country: customerConfig.defaultCountry || "US",
      emailOrder: true,
      consolidatePrint: true,
      residential: false,
      salesReps: [$session.salesRepId || $session.userAuthName],
      shippingLocation: { country: customerConfig.defaultCountry || "US" },
      accountType: customerConfig.defaultAccountType,
      priceList: customerConfig.defaultPriceList,
      paymentTerms: $session.meta && $session.meta.DefaultTerms,
      shippingMethod: $session.meta && $session.meta.DefaultShipMethod,
    };
    $ctrl.tagConfig = new AutoQuery({
      url: "QueryRetailerTagConfigs.json",
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "Position,TagKind",
      autoLoad: true,
      pageSize: 12,
    });
  }

  mapModel(model, action) {
    if (action !== "Delete") {
      const tags = model.tags;
      const newTags = {};
      for (const kind in tags) {
        if (tags[kind]) {
          if (Array.isArray(tags[kind])) newTags[kind] = tags[kind];
          else newTags[kind] = [tags[kind]];
        }
      }
      model.tags = newTags;
    }

    return model;
  }
  onLoaded(model) {
    if (model.stateTaxExpiration) {
      model.stateTaxExpiration = moment(model.stateTaxExpiration);
    }
  }
  getTitle(model, action, ctaTitle) {
    return `${ctaTitle || action} retailer...`;
  }
  getQueryUrl(model, action) {
    return `QueryRetailers.json?Id=${model && model.id}`;
  }
  getCommandUrl(model, action) {
    return `${action}Retailer.json`;
  }
  getModalBodyTemplateUrl(model, action) {
    return action === "Delete"
      ? deleteTemplate
      : action === "Start"
      ? startTemplate
      : fieldsetTemplate;
  }
  getModalSize(model, action) {
    return "sm retailer-prompt";
  }
  getController(model, action) {
    return RetailerPromptController;
  }
}
